import { render, staticRenderFns } from "./CalcIssueMain.vue?vue&type=template&id=561ef106&scoped=true"
import script from "./CalcIssueMain.vue?vue&type=script&lang=js"
export * from "./CalcIssueMain.vue?vue&type=script&lang=js"
import style0 from "./CalcIssueMain.vue?vue&type=style&index=0&id=561ef106&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561ef106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561ef106')) {
      api.createRecord('561ef106', component.options)
    } else {
      api.reload('561ef106', component.options)
    }
    module.hot.accept("./CalcIssueMain.vue?vue&type=template&id=561ef106&scoped=true", function () {
      api.rerender('561ef106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settle/CalcIssueMain.vue"
export default component.exports